'use strict';

import { Buffer } from 'buffer';
import Path from 'path';
import pluginError from 'plugin-error';
import through2 from 'through2';
import Vinyl from 'vinyl';
import * as util from '../utilities';
import * as SvgCode from './svg-code-convert';

const PLUGIN_NAME = 'gulp-svg-code';

/**
 * Plugin level function
 */
function gulpSvgCode() {
    // eslint-disable-next-line unused-imports/no-unused-vars
    function extendError(pError, error) {
        if (error && (typeof error === 'object')) {
            ['name', 'errno'].forEach(
                function (property) {
                    if (property in error) {
                        this[property] = error[property];
                    }
                },
                pError);
        }

        return pError;
    }

    let pathPrefix = null;
    const collection = {};
    return through2.obj(
        function (file, enc, cb) {
            let error = null;
            try {
                const path = Path.parse(file.path);
                if (path.ext === '.svg') {
                    if (pathPrefix === null) {
                        pathPrefix = path.dir;
                    } else {
                        const segments = path.dir.split('\\');
                        const segPrefix = pathPrefix.split('\\');
                        const newPrefix = [];
                        for (let i = 0; i < segPrefix.length; i++) {
                            if (segments[i].toLocaleUpperCase() !== segPrefix[i].toLocaleUpperCase()) {
                                pathPrefix = newPrefix.join('\\');
                                break;
                            }

                            newPrefix.push(segments[i]);
                        }
                    }

                    const data = file.contents.toString('utf8');
                    collection[file.path] = data;
                }
            } catch (e) {
                error = (!e.plugin || (e.plugin !== PLUGIN_NAME)) ?
                    util.extendError(new pluginError({ plugin: PLUGIN_NAME, message: e.message }), e) : e;
            }

            return cb(error);
        },
        function (cb) {
            const converter = new SvgCode.SvgCodeConverter();
            converter.contentReset();
            converter.generate(collection, pathPrefix);
            const cssFile = new Vinyl({
                cwd: '/',
                base: pathPrefix,
                path: pathPrefix + '\\svg.css',
                contents: Buffer.from(converter.contentCss, 'utf8')
            });

            this.push(cssFile);

            const tsFile = new Vinyl({
                cwd: '/',
                base: pathPrefix,
                path: pathPrefix + '\\svg.ts',
                contents: Buffer.from(converter.contentTs, 'utf8')
            });

            this.push(tsFile);
            cb();
        });
}

module.exports = gulpSvgCode;
